import axiosConfig from '../config/axios'

export default {
  data () {
    return {
      reward: null,
    }
  },
  methods: {
    configureOwnerItem(ownerItem) {
      const extensionOwnerItem = this.extension ? this.extension[ownerItem] : null
      return this[ownerItem] || extensionOwnerItem
    },

    loadReward(rewardOwnerKey = 'ownerType', rewardOwnerIdKey = 'ownerId') {
      const baseUrl = `/api/v3/campaign_rewards`,
        id = this.rewardId || this.offerId,
        url = id ? `${baseUrl}/${id}` : baseUrl,
        verb = id ? 'loading' : 'creating',
        rewardOwner = {
          owner_id: this.configureOwnerItem(rewardOwnerIdKey),
          owner_type: this.configureOwnerItem(rewardOwnerKey),
        },
        axiosCall = id ? axiosConfig.get(url, { params: rewardOwner }) : axiosConfig.post(url, rewardOwner)

      axiosCall
        .then((response) => {
          const rewardData = response.data.reward
          if (rewardData) {
            this.reward = rewardData
            this.setRewardData(rewardData)
          } else {
            this.setRewardLoadError(`issue ${verb} reward.`)
          }
        })
        .catch((error) => {
          this.setRewardLoadError(`issue ${verb} reward. ${error}`)
        })
    },
  },
}
